export default __webpack_public_path__ + "static/Sailec-Medium-675dcc5619e7cd2eaa881e3f6527fdda.woff";